import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'transferConfirmedPick';
export const transferConfirmedPickActions = makeActions(
  MODEL_NAME,
  'id',
  'transfer-orders',
);

export const getAllTransferConfirmedPick = transferConfirmedPickActions.getAll;
export const editTransferConfirmedPick = transferConfirmedPickActions.edit;
export const createTransferConfirmedPick = transferConfirmedPickActions.create;
export const getByIdTransferConfirmedPick =
  transferConfirmedPickActions.getDataById;
